import { render } from "./SelectProp.vue?vue&type=template&id=152f82c8&scoped=true"
import script from "./SelectProp.vue?vue&type=script&lang=js"
export * from "./SelectProp.vue?vue&type=script&lang=js"

import "./SelectProp.vue?vue&type=style&index=0&id=152f82c8&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-152f82c8"]])

export default __exports__